import { Box } from '@hover/blueprint';
import React from 'react';

import { RequestRevision } from 'src/modules/renderings/components/RenderingsHub/RenderingsList/RequestRevision';
import { CTA_BUTTON_CONTAINER_TEST_ID } from 'src/modules/renderings/components/RenderingsHub/RenderingsList/index';
import {
  useIsMobileSize,
  useIsSharedView,
  useIsTabletSize,
} from 'src/modules/renderings/hooks';

const SharedViewSecondaryCTA = () => null;

const MobileSizeSecondaryCTA = () => (
  <Box
    marginBottom={400}
    minWidth="248px"
    testId={CTA_BUTTON_CONTAINER_TEST_ID}
    width="100%"
  >
    <RequestRevision primaryCallToAction={false} />
  </Box>
);
const TabletSizeSecondaryCTA = () => null;

const DesktopSizeSecondaryCTA = () => (
  <Box
    marginBottom={400}
    minWidth="248px"
    testId={CTA_BUTTON_CONTAINER_TEST_ID}
    width="100%"
  >
    <RequestRevision primaryCallToAction={false} />
  </Box>
);
export const SecondaryCTA = () => {
  const isSharedView = useIsSharedView();
  const isTabletSize = useIsTabletSize();
  const isMobileSize = useIsMobileSize();

  if (isSharedView) {
    return <SharedViewSecondaryCTA />;
  }

  if (isMobileSize) {
    return <MobileSizeSecondaryCTA />;
  }

  if (isTabletSize) {
    return <TabletSizeSecondaryCTA />;
  }

  return <DesktopSizeSecondaryCTA />;
};
